import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-whats-new-banner',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './whats-new-banner.component.html',
})
export class WhatsNewBannerComponent {
    @Input() bannerData: any = null;
    bannerTitle: string = '';
    bannerDesc: string = '';
    bannerImageURL: string = '';
    bannerMobileImageURL: string = '';

    ngOnChanges() {
        this.parseBannerData(); // parsing and processing data
    }

    /**
     * @description Parses the banner data to extract the title and image URLs
     * @param none
     * @returns void
     */
    parseBannerData() {
        if (this.bannerData && this.bannerData.length > 0) {
            const data = this.bannerData[0];
            this.bannerTitle = data.campaigndetails.campaignName;
            this.bannerDesc = data.campaigndetails.campaignDescription;
            this.bannerImageURL =
                data.campaigndetails.bannerImageUrlArray?.[0] || '';
            this.bannerMobileImageURL =
                data.campaigndetails.bannerMobileImageUrlArray?.[0] || '';
        }
    }
}
